import { useEffect } from 'react';

import { ErrorModalProps } from './error-modal.component';

interface ViewProps {}

const useErrorModal = (props: ErrorModalProps): ViewProps => {
    useEffect(() => {
        if (props.show) {
            const timeout = setTimeout(() => {
                props.onClose && props.onClose();
            }, 30000); // Auto-close after 30 seconds
            return () => clearTimeout(timeout);
        }
        return;
    }, [props.show, props.onClose]);

    return {};
};

export default useErrorModal;
